import { createQueryString } from "@repo/lib/utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import NProgress from "nprogress";
import { useCallback, useState } from "react";

const useGridSelector = (initialColumns) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [currentColumns, setCurrentColumns] = useState(Number(initialColumns));

  const handleGridChange = useCallback(
    (colValue) => {
      if (colValue === currentColumns) return; // Prevent unnecessary state updates and router pushes
      setCurrentColumns(colValue); // Update the state immediately when clicking on the grid select button
      NProgress.start();
      const updatedQueryString = createQueryString(
        {
          columns: colValue,
        },
        searchParams
      );
      router.push(`${pathname}?${updatedQueryString}`);
    },
    [router, pathname, currentColumns, searchParams]
  );

  return {
    handleGridChange,
    currentColumns,
  };
};

export default useGridSelector;
